import axios from "axios";

// Tenant-scoped media library. The school is resolved server-side from the
// session (or the x-school-id header when a SuperAdmin is inside a school),
// so nothing here needs to pass a school id.
const API_URL = "/api/media";

/** Paginated listing. Filters: q, folder, type ("image"|"video"|"document"), mine. */
export const listMedia = async (params = {}) => {
  const { data } = await axios.get(API_URL, { params });
  return data;
};

/** Folder names with counts, for the library's folder filter. */
export const listFolders = async () => {
  const { data } = await axios.get(`${API_URL}/folders`);
  return data;
};

/** Upload one or more files into a folder. */
export const uploadMedia = async (files, { folder = "General", visibility = "school" } = {}) => {
  const form = new FormData();
  files.forEach((file) => form.append("files", file));
  form.append("folder", folder);
  form.append("visibility", visibility);
  const { data } = await axios.post(API_URL, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

/** Edit title / alt text / folder / tags / visibility. */
export const updateMedia = async (id, meta) => {
  const { data } = await axios.put(`${API_URL}/${id}`, meta);
  return data;
};

/** Delete the row and the file behind it. */
export const deleteMedia = async (id) => {
  const { data } = await axios.delete(`${API_URL}/${id}`);
  return data;
};

/** Human-readable file size, used by the library grid and details panel. */
export const formatBytes = (bytes) => {
  const n = Number(bytes) || 0;
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};

export const isImage = (item) => String(item?.mime_type || "").startsWith("image/");
export const isVideo = (item) => String(item?.mime_type || "").startsWith("video/");
